/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import MvnoBlockFunction from '../../interfaces/platform/MvnoBlockFunction';
import { MvnoBlockFunctionsCollection } from './BlockContainHelper';

const _ = require('underscore');

export class MvnoBlockFunctionLoader {
    private itemLoaders: ItemLoaders;

    private mvnoBlockFunctionsCollection: Array<MvnoBlockFunction> = [];

    constructor(itemLoader: ItemLoaders) {
        this.itemLoaders = itemLoader;
    }

    loadCollection = (
        callback: (data: MvnoBlockFunctionsCollection) => void | null,
        options = { propagateDataToCallback: true, dispatchAfterCallback: false, dispatchErrorAfterCallback: true }
    ): void => {
        this.itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_functions')),
            'mvno_block_functions_loader_loadCollection',
            [],
            [{ name: 'displayName', value: 'asc' }],
            (data: MvnoBlockFunctionsCollection) => {
                this.mvnoBlockFunctionsCollection = [];
                if (data['hydra:totalItems'] && data['hydra:totalItems'] > 0) {
                    data['hydra:member']?.map((item: MvnoBlockFunction) => {
                        this.mvnoBlockFunctionsCollection.push(item);
                    });
                }
                callback(data);
            },
            options
        );
    };

    loadItem = (
        mvnoBlockListId: number,
        callback: (mvnoBlockList: MvnoBlockFunction) => void,
        options = { propagateDataToCallback: true, dispatchAfterCallback: false }
    ): void => {
        this.itemLoaders.getWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists/' + mvnoBlockListId)),
            'mvno_block_function_item_loaders_loadItem',
            (data: MvnoBlockFunction): void => callback(data),
            options
        );
    };

    getCollection = (): Array<MvnoBlockFunction> => {
        return this.mvnoBlockFunctionsCollection;
    };

    getElementById = (blockId: number): MvnoBlockFunction | null => {
        return _.find(this.mvnoBlockFunctionsCollection, (item: MvnoBlockFunction) => {
            return item.id === blockId;
        });
    };

    getBlockNameById = (blockId: number): string | null => {
        const block = this.getElementById(blockId);
        return block ? 'prov:b.' + block.displayName : null;
    };
}
